
import React from 'react';
import { createTheme } from "@mui/material";
const theme = createTheme({
  // Customize your theme here
});

export default theme;